module.exports = __webpack_public_path__ + "img/wordmark.81799525.svg";